import {updateFactory} from '@modifi/redux'
import {
  NewPersonIdentificationView,
  getAuthenticatedThemisClient,
} from '@modifi/onboarding-api-clients'
import {PersonLegalRoleVal} from '@modifi/enums'
import {NestedError} from '../../../utils'

const apiClient = getAuthenticatedThemisClient()

const {actions} = updateFactory({
  rootSelector: state => state?.modules?.legalRoles?.link,
  actionNamePrefix: 'modules/legal-roles/link',
  submitRequest:
    (
      a,
      externalPersonId: string,
      legalRole: PersonLegalRoleVal,
      data: NewPersonIdentificationView
    ) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      try {
        const body: NewPersonIdentificationView = {
          ...data,
          legalRole,
        }

        await apiClient.Person.link({
          externalPersonId,
          body,
        }).then(res => res.data())

        dispatch(a.successAction())
      } catch (error: any) {
        dispatch(a.errorAction(error))
        throw new NestedError(`Error while calling Person.link endpoint`, error)
      }
    },
})

export const {aSubmit: aLinkPersonToLegalRole} = actions
